import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import {gtmSend, esCape} from '../../../helpers';
import history from '../../../other/history';
import {replyCommentSave, replyLike, replyDislike, replyEdit, commentsFetch, showLoginModal} from '../../../actions/index';
// import style from './style.css';
import ReplyCardComponent from '../../../components/Common/CardComponents/Reply';
import {ReplyFeedCardComponent} from '../../../components/Common/CardComponents/Reply';
import ReplyGenericInputModal from '../../../components/Common/CardComponents/ReplyGenericInputModal';
import CommentInputCard from '../../../components/Common/CardComponents/CommentInputCard';
import ShareModal from '../../../components/Common/CardComponents/Share';
import {buildMapping} from '../../../other/ActionMapper';
// import Loader from '../../../components/Common/Loader';
// import {Icon} from '../../../components/Common/Icon';
import {getUrlParameter} from '@tickled-media/web-components.tm-helpers';
// import cx from '../../../styles';

class ReplyCardContainer extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            commentPage: 1,
            isCommentModalOpen: false, commentContent:"", modalImagePreviews: [], modalImages: [],
            isEditReplyModalOpen: false, editReplyContent: '',
            isShareModalOpen: false,
            isLoading: false,
            isCommentsLoading: false,
            cardName: '',
            isValidData: false,
            replyModalImages: [],
            replyModalImagePreviews: [],
            showUploadInput: true,
            likeErrorMessage: ""
        };
    }

    componentDidMount() {
        if(history.location.state && 'shouldOpenCommentDialog' in history.location.state){            
            if(history.location.state.shouldOpenCommentDialog && history.location.state.replyId == this.props.reply.id) {
                this.toggleCommentModal();            
            }
        }
        //
        if(history.location.state && 'shouldOpenREditDialog' in history.location.state){            
            if(history.location.state.shouldOpenREditDialog && history.location.state.replyId == this.props.reply.id) {
                this.openEditReplyModal();
            }
        }
    }

    goToSingleView = (state=null) => {
        history.push({
            pathname: `/q/${this.props.slug}/${this.props.postId}`,
            ...(state && {state})
        });
    }

    goToSingleReplyView = (state=null) => {
        history.push({
            pathname: `/q/${this.props.slug}/${this.props.postId}?replyId=${this.props.reply.id}`,
            ...(state && {state})
        });
    }

    onLikeClick = () => {
        const { postReducer } = this.props;
        if(!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `upvote | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `upvote | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        }
        else if(!this.state.isLoading) {
            const {reply, postId, inFeed, match} = this.props;
            if(this.state.cardName){
                gtmSend('dynamic', this.state.cardName, `click-${(reply.likes.liked ? 'remove like' : 'like')}`, match.path);
                gtmSend('cw_reaction', `${this.state.cardName}`, 'Reaction', `${(reply.likes.liked ? 'remove like' : 'Like')}`, 0, {card_type: `${this.state.cardName}`, reply_id: `${reply.id}`, topic_name: `${postReducer.data.topic.group.name}`, topic_id: `${postReducer.data.topic.group.id}`});
            }else{
                gtmSend('click reply upvote', 'card-reply', `click:${(reply.likes.liked ? 'remove like' : 'like')}`, reply.id);
            }
            if(reply.likes.liked){
                this.setState({isLoading: true});
                this.props.replyLike(postId, inFeed, reply.id, 'remove_like')
                .then(() => {
                    this.setState({isLoading: false});
                });
            }
            else{
                this.setState({isLoading: true});
                this.props.replyLike(postId, inFeed, reply.id, 'like')
                .then((data) => {
                    if(data){
                        this.setState({likeErrorMessage: data})
                    }
                    this.setState({isLoading: false});
                });
            }
        }
    }

    onDislikeClick = () => {
        const { postReducer } = this.props;
        if(!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `downvote | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `downvote | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        }
        else if(!this.state.isLoading) {
            const {reply, postId, inFeed, match} = this.props;
            if(this.state.cardName){
                gtmSend('dynamic', this.state.cardName, `click-${(reply.dislikes.disliked ? 'remove dislike' : 'dislike')}`, match.path);
                gtmSend('cw_reaction', `${this.state.cardName}`, 'Reaction', `${(reply.dislikes.disliked ? 'remove dislike' : 'dislike')}`, 0, {card_type: `${this.state.cardName}`, reply_id: `${reply.id}`, topic_name: `${postReducer.data.topic.group.name}`, topic_id: `${postReducer.data.topic.group.id}`});
            }else{
                gtmSend('click reply downvote', 'card-reply', `click:${(reply.dislikes.disliked ? 'remove dislike' : 'dislike')}`, reply.id);
            }
            if(reply.dislikes.disliked){
                this.setState({isLoading: true});
                this.props.replyDislike(postId, inFeed, reply.id, 'remove_dislike')
                .then(() => {
                    this.setState({isLoading: false});
                });
            }
            else{
                this.setState({isLoading: true});
                this.props.replyDislike(postId, inFeed, reply.id, 'dislike')
                .then((data) => {
                    if(data){
                        this.setState({likeErrorMessage: data})
                    }
                    this.setState({isLoading: false});
                });
            }
        }
    }

    onReplyClick = () => {
        if(this.state.cardName){
            gtmSend('dynamic', this.state.cardName, 'click-comment', this.props.match.path);
        }
        if(!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `reply comment | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `reply comment | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        } else {
            this.props.inFeed
            ? this.goToSingleView()
            : this.toggleCommentModal();
            // this.goToSingleView({shouldOpenCommentDialog: true, replyId: this.props.reply.id})
        }        
    }
    
    toggleCommentModal = () => {
        const isCommentModalOpen = this.state.isCommentModalOpen;
        this.setState({isCommentModalOpen: !isCommentModalOpen});
    }

    closeCommentModal = () => {
        this.setState({isCommentModalOpen: false, isValidData: false, commentContent: ""});
    }

    onCommentModalOpen = () => {
        //dialog fix
        const state = {};
        history.replace({...history.location, state});
    }

    onCommentModalClose = () => {
        this.setState({isCommentModalOpen: false});
    }

    onCommentModalContentChange = (content) => {
        this.setState({commentContent: content});
    }

    onCommentModalImageUpload = (e) => {        
        if(e.target.files.length) {
            gtmSend('dynamic', 'Reply Comment Compose', 'click-image-upload', '');
            for(let k = 0; k < e.target.files.length; k++) {
                const reader = new FileReader();
                reader.readAsDataURL(e.target.files[k]);
                reader.onload = (i) => {
                    const base64Result = i.target.result;
                    this.setState({
                        modalImagePreviews: [...this.state.modalImagePreviews, base64Result],
                        modalImages: [...this.state.modalImages, base64Result.split(',')[1]]
                    });
                };            
            }
        }
    }

    onCommentModalSubmit = (e) => {
        this.setState({isValidData: true});
        e.preventDefault();
        const message = esCape(this.state.commentContent);
        if(!message.length)
        { 
            this.setState({isValidData: false});
            return this._addNotificationToModal(this.props.t('you_need_to_type_something'), 'error');
        }
        const { postReducer } = this.props;
        const anonymous = e.target.anonymous.value,
            replyId = this.props.reply.id,
            replyIndex = this.props.replyIndex;
        // let cardIndex = this.props.cardIndex;
        // gtmSend('submit comment', 'card-reply', 'submit:comment', replyId);
        gtmSend('dynamic', 'Reply Comment Compose', 'click-submit', `submit:${this.props.postId - replyId}`);
        gtmSend('cw_reply_comment', `Reply Card`, 'Comment On Reply', `${anonymous === '1' ? 'Anonymous': 'Identified'} - ${postReducer.data.topic.group.name}`, 0, {card_id: postReducer.id, reply_id: replyId});
        //submit
        this.props.replyCommentSave(this.props.postId, replyIndex, replyId, message, anonymous)
        .then(()=>{
            if(!this.props.postReducer.error)
            {
               this.closeCommentModal();
            }else{
                this.setState({isValidData: false});
                return this._addNotificationMessageToModal(this.props.postReducer.error, 'error');
            }
            });
    }

    openEditReplyModal = () => {
        this.setState({isEditReplyModalOpen: true});
    }

    closeEditReplyModal = () => {
        this.setState({isEditReplyModalOpen: false, isValidData: false, replyModalImages: [], replyModalImagePreviews: [], showUploadInput: true});
    }

    onEditReplyModalOpen = () => {
        this.populateReplyImages(this.props.reply.images);
        this.setState({editReplyContent: this.props.reply.message});
        //dialog fix
        const state = {};
        history.replace({...history.location, state});
    }

    onEditReplyModalSubmit = (e) => {
        this.setState({isValidData: true});
        e.preventDefault();
        const message = esCape(this.state.editReplyContent);
        if(!message.length) return this._addNotificationToModal(this.props.t('you_need_to_type_something'), 'error');
        // let anonymous = e.target.anonymous.value;
        // let isActive = 1;
        const answerId = this.props.reply.id;
        gtmSend('dynamic', 'Reply Card Edit', 'click-submit', `submit:${this.props.postReducer.id - answerId}`);

        if (this.state.replyModalImages.length) {
            this.props.replyEdit(this.props.postId, this.props.replyIndex, answerId, message, this.state.replyModalImages[0])
            .then(() =>{
               if(!this.props.postReducer.error) {
                    this.closeEditReplyModal();
               }else {
                    this.setState({isValidData: false}); 
                    return this._addNotificationMessageToModal(this.props.postReducer.error, 'error');
               }
            });
        }
        else{
            this.props.replyEdit(this.props.postId, this.props.replyIndex, answerId, message)
            .then(()=>{
                if(!this.props.postReducer.error)
                {
                    this.closeEditReplyModal();
                }else{
                    this.setState({isValidData: false});
                    return this._addNotificationMessageToModal(this.props.postReducer.error, 'error');
                }
            });
        }
    }

    share = () => {
        if(this.state.cardName){
            const { postReducer } = this.props;
            gtmSend('dynamic', this.state.cardName, 'click-share', this.props.match.path);
            gtmSend('cw_post_reply_share', 'Post', 'Reply Share', `--`,  `${postReducer.id}`);
        }
        this.setState({isShareModalOpen: true});
    }

    onCommentsFetch = () => {
        if (this.props.singleReplyMode && getUrlParameter('commentId')) {
            this.goToSingleReplyView();
            // window.location.reload(true);
        } else {
            const page = this.state.commentPage;
            this.setState({isCommentsLoading: true});
            this.props.commentsFetch(this.props.reply.id, Number(page) + 1)
            .then(() => {
                this.setState({
                    isCommentsLoading: false,
                    commentPage: Number(page) + 1
                });
            });
        }
    }   

    setCardName = (name) => {
        this.setState({
            cardName: name
        });
    }    

    onHashReplyClick = () => {
        gtmSend('dynamic', 'Reply Card Edit', 'click-hash', '');
        let editReplyContent = this.state.editReplyContent;
        editReplyContent += ' #';
        this.setState({editReplyContent});
        document.getElementById("generic-input-modal-desc").focus();
    } 

    onHashCommentClick = () => {
        gtmSend('dynamic', 'Reply Comment Compose', 'click-hash', '');
        let commentContent = this.state.commentContent;
        commentContent += ' #';
        this.setState({commentContent});
        document.getElementById("generic-input-modal-desc").focus();
    }

    onReplyModalImageUpload = (e) => {        
        if(e.target.files.length) {
            gtmSend('dynamic', 'Reply Card Edit', 'click-image-upload', '');
            for(let k = 0; k < e.target.files.length; k++) {
                const reader = new FileReader();
                reader.readAsDataURL(e.target.files[k]);
                reader.onload = (i) => {
                    const base64Result = i.target.result;
                    this.setState({
                        replyModalImagePreviews: [...this.state.replyModalImagePreviews, base64Result],
                        replyModalImages: [...this.state.replyModalImages, base64Result.split(',')[1]],
                        showUploadInput: false
                    });
                };            
            }
        }
    }

    onPreviewImageRemove = (index) => {
        gtmSend('dynamic', 'Reply Card Edit', 'click-remove-image-preview', '');
        this.setState({
            replyModalImagePreviews: [...this.state.replyModalImagePreviews.slice(0, index), ...this.state.replyModalImagePreviews.slice(index+1)],
            replyModalImages: [...this.state.replyModalImages.slice(0, index), ...this.state.replyModalImages.slice(index+1)],
            showUploadInput: true
        });
    } 

    populateReplyImages = (images = []) => {
        if (images.length) {
            //empty
            this.setState({
                replyModalImagePreviews: [],
                replyModalImages: []
            });
            for (const k in images) {
                this.imageUrlToData(images[k].image, (d) => {
                    this.setState({
                        replyModalImagePreviews: [...this.state.replyModalImagePreviews, d],
                        replyModalImages: [...this.state.replyModalImages, d.split(',')[1]],
                        showUploadInput: false
                    });
                });
            }
        }
    } 

    imageUrlToData = (url, callback) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = function () {
            const reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    render() {
        const {t, reply, inFeed, postId, slug, replyIndex, configReducer, appReducer, userReducer, match, status, topic} = this.props,
        responseBar = {
            replyCount: reply.comments.length + reply.more_comment_count,
            likes: reply.likes,
            dislikes: reply.dislikes,
            onLikeClick: this.onLikeClick,
            onDislikeClick: this.onDislikeClick,
            onReplyClick: this.onReplyClick,
            onShareClick: this.share
        },
        replyActions = buildMapping(
            'answer',
            reply.actions,
            {
                id: reply.id,
                postId,
                replyIndex,
                cardName: 'Reply Card',
                topic: topic,
                position: (typeof document != 'undefined' ? document.documentElement.scrollTop : 0),
                adminUrl: (reply.backend_url ? reply.backend_url : ''),
                authorId: reply.user.id,
                authorName: reply.user.fullname,
                elemRef: this,
                inFeed,
                t
            },
            this.context.store.dispatch
        );
        reply.actions = replyActions;
        //comments
        for(const i in reply.comments) {
            reply.comments[i].actions = buildMapping(
                'comment',
                reply.comments[i].actions,
                {
                    postId,
                    replyId: reply.id,
                    replyIndex,
                    cardName: 'Reply Comment Card',
                    topic: topic,
                    id: reply.comments[i].id,
                    authorId: reply.comments[i].user.id,
                    authorName: reply.comments[i].user.fullname,
                    elemRef: this,
                    inFeed,
                    t,
                    position: (typeof document != 'undefined' ? document.documentElement.scrollTop : 0)
                },
                this.context.store.dispatch
            );
        }

        let lastSeenUrl = `${configReducer.siteUrl}q/${slug}/${postId}?replyId=${reply.id}`;
        
        if(getUrlParameter('replyId')) {
            lastSeenUrl = '';
        }

        return (
            <React.Fragment>

                {
                    inFeed
                    ?
                        <ReplyFeedCardComponent reply={reply}                    
                            inFeed={inFeed}
                            appReducer={appReducer}
                            responseBar={responseBar}
                            t={t}
                            siteUrl={configReducer.siteUrl}
                            url={`${configReducer.siteUrl}q/${slug}/${postId}?replyId=${reply.id}`}
                            onCommentsFetch={this.onCommentsFetch}
                            match={match}
                            cardName='Question Reply Card'
                            setCardName= {this.setCardName} />
                    :
                        <ReplyCardComponent reply={reply}                    
                            inFeed={inFeed}
                            appReducer={appReducer}
                            isLoading={this.state.isLoading}
                            isCommentsLoading={this.state.isCommentsLoading}
                            responseBar={responseBar}
                            postId={this.props.postId}
                            t={t}
                            siteUrl={configReducer.siteUrl}
                            url={lastSeenUrl}
                            onCommentsFetch={this.onCommentsFetch}
                            userId={userReducer.id}
                            showLoginModal={this.props.showLoginModal}
                            match={match}
                            status={status}
                            replyId={reply.id}
                            topic={topic}
                            likeErrorMessage={this.state.likeErrorMessage}
                            cardName='Reply Card'
                            setCardName= {this.setCardName}
                            isSingleReplyLastSeen={lastSeenUrl ? false : true} />
                }

                {
                    !inFeed && this.state.isCommentModalOpen &&
                    <CommentInputCard
                        eventHandlers={{
                            onSubmit: this.onCommentModalSubmit,
                            onContentChange: this.onCommentModalContentChange,
                            onCloseClick: this.closeCommentModal,
                            refAddNotificationMessage: (f) =>this._addNotificationMessageToModal = f,
                            refAddNotification: (f) => this._addNotificationToModal = f
                        }}
                        siteUrl={configReducer.siteUrl}
                        author={reply.user}
                        gtmLabel={'Reply Comment Compose'}
                        content={this.state.commentContent}
                        showAnonymous={userReducer.country === 'id' ? false : true}
                        id={reply.id}
                    />
                }
                {/* 
                    !inFeed && this.state.isCommentModalOpen &&
                    <ReplyGenericInputModal isModalOpen={this.state.isCommentModalOpen}
                        eventHandlers={{
                            onModalOpen: this.onCommentModalOpen,
                            onModalClose: this.onCommentModalClose,
                            onImageUpload: this.onCommentModalImageUpload,
                            onSubmit: this.onCommentModalSubmit,
                            onContentChange: this.onCommentModalContentChange,
                            refAddNotificationMessage: (f) =>this._addNotificationMessageToModal = f,
                            refAddNotification: (f) => this._addNotificationToModal = f,
                        }}
                        gtmLabel={'Reply Comment Compose'}
                        content={this.state.commentContent}
                        user={userReducer}                        
                        imagePreviews={this.state.modalImagePreviews}
                        mobileTitle={t('add_reply_second_level_placeholder')}
                        contentPlaceholder={t('add_reply_second_level_placeholder')}
                        buttonLabel={t('add_reply_post')}
                        isComment={true}
                        isValidData={this.state.isValidData} /> 
                */}

                { 
                    !inFeed && this.state.isEditReplyModalOpen &&
                    <ReplyGenericInputModal isModalOpen={this.state.isEditReplyModalOpen}
                        eventHandlers={{
                            onModalOpen: this.onEditReplyModalOpen,
                            onModalClose: () => this.setState({isEditReplyModalOpen: false, editReplyContent: reply.message}),
                            onSubmit: this.onEditReplyModalSubmit,
                            onImageUpload: this.onReplyModalImageUpload,
                            onContentChange: v => this.setState({editReplyContent: v}),
                            onHashClick: this.onHashReplyClick,
                            onPreviewImageRemove: this.onPreviewImageRemove,
                            refAddNotification: (f) => this._addNotificationToModal = f,
                            refAddNotificationMessage: (f) => this._addNotificationMessageToModal = f
                        }}       
                        gtmLabel={'Reply Card Edit'}                 
                        content={this.state.editReplyContent}
                        imagePreviews={this.state.replyModalImagePreviews}
                        user={userReducer}
                        showUploadInput={this.state.showUploadInput}
                        showAnonymous={userReducer.country === 'id' ? false : true}
                        showNSFW={false}
                        ifEditing={true}
                        isReply={true}
                        buttonLabel={t('add_reply_edit_save')}
                        isValidData={this.state.isValidData} /> 
                }

                {   
                    <ShareModal isModalOpen={this.state.isShareModalOpen}
                        position={typeof document != 'undefined' ? document.documentElement.scrollTop : 0}
                        shareType='reply'
                        cardName= 'Reply Card'
                        id={reply.id}
                        siteUrl={configReducer.siteUrl}
                        slug={`q/${slug}/${postId}?replyId=${reply.id}`}
                        username={userReducer.fullname}
                        topic={topic}
                        t={t}
                        onModalClose={()=>this.setState({isShareModalOpen: false})} />
                }
            </React.Fragment>
        );
    }

}

ReplyCardContainer.contextTypes = {
    store: PropTypes.object.isRequired
};

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
};

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        replyCommentSave,
        replyLike,
        replyDislike,
        replyEdit,
        commentsFetch,
        showLoginModal
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(ReplyCardContainer));
